import { Link } from "react-router-dom";
import "./ButtonUI.css";

const ButtonUI = ({
  text,
  to,
  variant = "primary",
  theme = "default",
  className = "",
  ...rest
}) => {
  const classes = [
    "button",
    `button--${variant}`,
    `button--${theme}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (to) {
    const isExternal = typeof to === "string" && to.startsWith("http");

    return isExternal ? (
      <a href={to} className={classes} {...rest}>
        {text}
      </a>
    ) : (
      <Link to={to} className={classes} {...rest}>
        {text}
      </Link>
    );
  }

  return (
    <button className={classes} {...rest} dangerouslySetInnerHTML={{ __html: text }}></button>
  );
};

export default ButtonUI;
